import { useRecoilCallback } from "recoil";
import type { TourVariant } from "../lib/tour/tour";
import { AiChatLevelAtom } from "../state/aiChatAtoms";
import { PersistOwnerNameAtom } from "../state/authAtoms";
import {
	ShowStacks,
	ShowStacksDuringDemoMode,
	StackCfKeyAtom,
} from "../state/stackAtoms";
import {
	DemoMode,
	PendingTourStepAtom,
	SelectedTourVariantAtom,
	ShowTour,
	ShowTourSelectionAtom,
} from "../state/uiAtoms";

/**
 * Starts a tour in demo mode. The demo runs on its own stack, so the
 * user's open presentation is untouched (callers should still save a
 * dirty editor first). Pass `startStep` to open at a section instead
 * of the beginning.
 */
export function useStartTour() {
	return useRecoilCallback(
		({ set, snapshot }) =>
			(variant: TourVariant, startStep?: number) => {
				const persistedOwnerName = snapshot
					.getLoadable(PersistOwnerNameAtom)
					.getValue();
				set(SelectedTourVariantAtom, variant);
				set(ShowTourSelectionAtom, false);
				// the stories popup would otherwise sit on top of the tour —
				// both the normal panel and the demo-mode variant
				set(ShowStacks, false);
				set(ShowStacksDuringDemoMode, false);
				set(PendingTourStepAtom, startStep ?? null);
				set(ShowTour, true);
				set(DemoMode, true);
				set(AiChatLevelAtom, 1);
				set(StackCfKeyAtom, persistedOwnerName);
			},
	);
}
